<permission-checker [roles]="roles" (contentInit)="initContent()" (rolesLoaded)="rolesUpdated($event)">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Competition details|Competition details title@@competition-details-title">Competition Details</h1>

        <div class="fill-space"></div>

        <app-button *ngIf="editAllowed"
                    label="Edit"
                    i18n-label="General|Edit action label@@general-edit-action-label"
                    color="primary"
                    (clicked)="editCompetition()"></app-button>
      </mat-toolbar-row>
    </mat-toolbar>

    <app-no-content *ngIf="!inProgress && !competition"
                    [compact]="true"
                    title="Please select a competition first"
                    i18n-title="Contest Details|No competition selected title@@competition-details-not-selected-title"
                    details="Competition details will be loaded once selected"
                    i18n-details="Contest Details|No competition selected details@@competition-details-not-selected-details"></app-no-content>

    <div class="content page">
      <mat-spinner *ngIf="inProgress" [diameter]="40" class="center-middle" color="primary"></mat-spinner>

      <div *ngIf="!inProgress && competition">
        <mat-card class="competition-card center">
          <mat-card-header>
            <div mat-card-avatar class="competition-logo" matRipple [matRippleCentered]="true"
                 [style.background-image]="'url(' + competition.logoUrl +')'"
                 [class.editor]="editAllowed"
                 matTooltip="Change logo"
                 [matTooltipDisabled]="!editAllowed"
                 i18n-matTooltip="Contest Details|Change logo tooltip@@competition-details-change-logo-tooltip">
              <mat-icon *ngIf="editAllowed">edit</mat-icon>
            </div>
            <mat-card-title>{{competition.name}}</mat-card-title>
            <mat-card-subtitle>
              <span class="text-disabled-color"
                    i18n="Contest Details|Last updated field title@@competition-details-last-updated-field-title">Last Updated:</span>&nbsp;
              <span>{{competition.modifiedAt | date:'medium' }}</span>
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p *ngIf="competition.description" [innerHTML]="sanitizer.bypassSecurityTrustHtml(competition.description)"></p>
            <p *ngIf="!competition.description" class="text-disabled-color"
               i18n="Contest Details|No description placeholder@@competition-details-no-description-placeholder">No
              description provided...</p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</permission-checker>
